export default __webpack_public_path__ + "static/beerlao-395b3959b1eb507a0873601c74e30c6c.png";